import React from "react";
import { Text } from "react-native";
class QuickAccess {
  constructor(
    id = 0,
    uId = null,
    name = "",
    icon = "",
    type = "",
    buildingId = ""
  ) {
    this.id = id;
    this.uId = uId;
    this.name = name;
    this.icon = icon;
    this.type = type;
    this.buildingId = buildingId;
  }
  // render() {
  //     return (
  //         <Text>"successFul"</Text>
  //     );
  // }
}
export default QuickAccess;
